import * as React from 'react';
import { useCallback } from 'react';
import { ExchangeRefundCreateForm } from '@entities/order';
import { useCreateExchange } from '../../model/useCreateExchange';
const CreateExchangeForm = ({ className, title, description, initialValues, isRequiredComment, order, onSuccess }) => {
    const { onCreateExchange, isLoading } = useCreateExchange();
    const onSubmit = useCallback((data) => {
        onCreateExchange({ createExchangeParams: data, onSuccess });
    }, [onSuccess, onCreateExchange]);
    return (React.createElement(ExchangeRefundCreateForm, { type: "exchange", className: className, title: title, description: description, initialValues: initialValues, isLoading: isLoading, requiredComment: isRequiredComment, order: order, onSubmit: onSubmit }));
};
export default CreateExchangeForm;
